import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { AdminCreateEarlyDismissalData, adminEarlyDismissalsApi } from '@/services';

export const adminEarlyDismissalsKeys = {
  all: ['admin', 'early-dismissals'] as const,
  list: () => ['admin', 'early-dismissals', 'list'] as const,
  detail: (id?: string) => ['admin', 'early-dismissals', 'detail', id ?? null] as const,
};

export function useAdminEarlyDismissalsListQuery() {
  return useQuery({
    queryKey: adminEarlyDismissalsKeys.list(),
    queryFn: () => adminEarlyDismissalsApi.list(),
  });
}
export function useAdminEarlyDismissalQuery(id?: string) {
  return useQuery({
    queryKey: adminEarlyDismissalsKeys.detail(id),
    queryFn: () => adminEarlyDismissalsApi.detail(id as string),
    enabled: Boolean(id),
  });
}
export function useCreateEarlyDismissalOnBehalfMutation() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: AdminCreateEarlyDismissalData) => adminEarlyDismissalsApi.createOnBehalf(data),
    onSuccess: () => qc.invalidateQueries({ queryKey: adminEarlyDismissalsKeys.all }),
  });
}
export function useDeleteEarlyDismissalMutation() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => adminEarlyDismissalsApi.remove(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: adminEarlyDismissalsKeys.all }),
  });
}
